import React from "react";

const PreviewContext = React.createContext({
  apiKey: undefined,
});

export default PreviewContext;
